<template>
  <div
    class="z-999 max-h-[75vh] rounded-t-5 md-max-h-none md-rounded-0 md-h-full overflow-y-hidden transition transform absolute right-0 bottom-0 w-full md-w-[320px] bg-white"
  >
    <slot />
  </div>
</template>
